module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-19.c33408d1.jpg";